module.exports = __webpack_public_path__ + "static/media/tapir-grey.dc1be701.png";